import { LearningProgressListPage } from "@/features/learning-progress/pages/LearningProgress";

const LearningProgressList = () => {
  return <LearningProgressListPage />;
};

export default LearningProgressList;
